<!-- Overlay backdrop -->
<div
  class="modal fade show d-block"
  tabindex="-1"
  style="background-color: rgba(0, 0, 0, 0.5)"
  (click)="closeClick.emit()"
>
  <div
    class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-content">
      <!-- Header -->
      <div
        class="modal-header text-white"
        style="background: linear-gradient(90deg, #3366cc 0%, #0039a6 100%)"
      >
        <h2 class="mb-0 fs-5">
          <i class="bx bxs-detail bx-sm"></i>
          Detalle del Resumen de Atención en Salud
        </h2>
        <button
          type="button"
          class="btn-close btn-close-white"
          (click)="closeClick.emit()"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <!-- Origen del documento -->
        @if (entry()._source || entry()._sourceLabel) {
          <div class="document-origin mb-3">
            <i class="bx bx-info-circle"></i>
            <strong>Origen del documento:</strong>
            <span class="badge bg-success ms-2">
              <i class="bx bxs-file-medical"></i>
              {{ entry()._sourceLabel || entry()._source }}
            </span>
          </div>
        }

        <!-- Sección: Datos del Paciente -->
        @if (patientData()) {
          <div class="section-header-green">
            <i class="bx bx-user"></i>
            Datos del Paciente
          </div>
          <div class="section-body">
            <div class="row g-2">
              <div class="col-md-6">
                <p class="mb-2">
                  <strong>Activo:</strong> {{ patientData()!.activo ? 'Sí' : 'No' }}
                </p>
                <p class="mb-2">
                  <strong>Fallecido:</strong> {{ patientData()!.fallecido ? 'Sí' : 'No' }}
                </p>
                <p class="mb-2"><strong>Nombre:</strong> {{ patientData()!.nombres }}</p>
                <p class="mb-2"><strong>Documento:</strong> {{ patientData()!.documento }}</p>
                @if (patientData()!.tipoDocumento) {
                  <p class="mb-2">
                    <strong>Tipo de documento:</strong> {{ patientData()!.tipoDocumento!.code }} –
                    {{ patientData()!.tipoDocumento!.display }}
                  </p>
                }
                <p class="mb-2">
                  <strong>Fecha de Nacimiento:</strong> {{ patientData()!.fechaNacimiento }}
                </p>
                @if (patientData()!.horaNacimiento) {
                  <p class="mb-2">
                    <strong>Hora de Nacimiento:</strong> {{ patientData()!.horaNacimiento }}
                  </p>
                }
                <p class="mb-2"><strong>Edad:</strong> {{ patientData()!.edad }} años</p>
              </div>
              <div class="col-md-6">
                @if (patientData()!.paisResidencia) {
                  <p class="mb-2">
                    <strong>País de Residencia:</strong> {{ patientData()!.paisResidencia }}
                  </p>
                }
                @if (patientData()!.municipioResidencia) {
                  <p class="mb-2">
                    <strong>Municipio de Residencia:</strong>
                    {{ patientData()!.municipioResidencia }}
                  </p>
                }
                @if (patientData()!.sexoBiologicoExt) {
                  <p class="mb-2">
                    <strong>Sexo Biológico (extensión):</strong>
                    {{ patientData()!.sexoBiologicoExt }}
                  </p>
                }
                @if (patientData()!.identidadGenero) {
                  <p class="mb-2">
                    <strong>Identidad de Género:</strong> {{ patientData()!.identidadGenero }}
                  </p>
                }
                @if (patientData()!.nacionalidad) {
                  <p class="mb-2">
                    <strong>Nacionalidad:</strong> {{ patientData()!.nacionalidad }}
                  </p>
                }
                @if (patientData()!.zonaResidencia) {
                  <p class="mb-2">
                    <strong>Zona de Residencia:</strong> {{ patientData()!.zonaResidencia }}
                  </p>
                }
                @if (patientData()!.divipolaMunicipio) {
                  <p class="mb-2">
                    <strong>DIVIPOLA Municipio:</strong> {{ patientData()!.divipolaMunicipio }}
                  </p>
                }
                @if (patientData()!.codigoPais) {
                  <p class="mb-2"><strong>Código país:</strong> {{ patientData()!.codigoPais }}</p>
                }
                @if (patientData()!.etnia) {
                  <p class="mb-2"><strong>Etnia:</strong> {{ patientData()!.etnia }}</p>
                }
                @if (patientData()!.discapacidad) {
                  <p class="mb-2">
                    <strong>Tipo Discapacidad:</strong> {{ patientData()!.discapacidad }}
                  </p>
                }
              </div>
            </div>
          </div>
          <hr />
        }

        <!-- 2. Organizaciones -->
        @if (organizations().length > 0) {
          <app-organizations-section [organizations]="organizations()" />
          <hr />
        }

        <!-- 3. Profesionales -->
        @if (practitioners().length > 0) {
          <app-practitioners-section [practitioners]="practitioners()" />
          <hr />
        }

        <!-- 4. Encuentro Clínico -->
        @if (encounterData()) {
          <app-encounter-section [encounter]="encounterData()!" />
        }

        <!-- 5. Condiciones / Diagnósticos -->
        @if (conditions().length > 0) {
          <app-conditions-section [conditions]="conditions()" />
        }

        <!-- 6. Alergias -->
        @if (allergies().length > 0) {
          <app-allergies-section [allergies]="allergies()" />
        }

        <!-- 7. Medicamentos -->
        @if (
          medAdministrations().length > 0 || medRequests().length > 0 || medStatements().length > 0
        ) {
          <app-medications-section
            [administrations]="medAdministrations()"
            [requests]="medRequests()"
            [statements]="medStatements()"
          />
        }

        <!-- 8. Procedimientos -->
        @if (procedures().length > 0) {
          <app-procedures-section [procedures]="procedures()" />
        }

        <!-- 9. Observaciones -->
        @if (observations().length > 0) {
          <app-observations-section [observations]="observations()" />
        }

        <!-- 10. Factores de Riesgo -->
        @if (riskAssessments().length > 0) {
          <app-risk-section [riskAssessments]="riskAssessments()" />
        }

        <!-- 11. Antecedentes Familiares -->
        @if (familyHistories().length > 0) {
          <app-family-history-section [familyHistories]="familyHistories()" />
        }

        <!-- 12. Referencias Documentales (oculto temporalmente) -->
        @if (false) {
          <app-document-references-section [documentReferences]="documentReferences()" />
        }

        <!-- 13. Información Adicional (cuando no hay recursos clínicos) -->
        @if (
          !encounterData() &&
          conditions().length === 0 &&
          allergies().length === 0 &&
          medAdministrations().length === 0 &&
          medRequests().length === 0 &&
          medStatements().length === 0 &&
          procedures().length === 0 &&
          observations().length === 0 &&
          riskAssessments().length === 0 &&
          familyHistories().length === 0 &&
          documentReferences().length === 0
        ) {
          <div class="info-adicional">
            <i class="bx bx-info-circle"></i>
            <strong>Información Adicional</strong>
            <p class="mb-0 mt-1">
              No se encontraron recursos adicionales para este paciente en este RDA.
            </p>
          </div>
        }
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeClick.emit()">
          <i class="bx bx-x"></i> Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
